<div class="aboutCompanyWrapper" id="aboutus">
    <div class="container">
        <div class="row">
            <div class="col title">
                <h6>About Company</h6>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 heading">
                <h2>Everyone in your <span class="txtColor">organization</span> can make an impact with <span
                        class="txtColor">AI</span></h2>
            </div>
        </div>
        <div class="videoWrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <div class="videoLink">
                            <img src="assets/images//videoImage.png" alt="">
                            <a href="#"><i class="fa fa-play"></i></a>
                        </div>
                    </div>
                    <div class="col-lg-6 videoTxt">
                        <h2>Innovate within your existing workflow</h2>
                        <p>LOT  Cloud AI helps solve your most important business problems end-to-end with
                            prepackaged solutions. Realize the value of your AI investment sooner, put AI in the
                            hands of those closest to your business, and reduce friction to adoption across your
                            organization.</p>
                        <a href="#contactDetails">Talk to a consultant </a>
                    </div>
                    <p class="leftBorder">Retailer Marks & Spencer created better customer experience with
                        Contact Center AI from LOT  Cloud.</p>
                </div>
            </div>
        </div>
    </div>
</div>